import Cookies from "js-cookie";
import axiosInstance from "./http-common";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};

/**
 * Calculates remaining height for a container
 * @param {Number} pixels Pixel Value in number
 * @returns {Number} remainingHeight - viewportHeight - pixels
 */

export const calculateRemainingHeight = (pixels) => {
  const viewportHeight = window.innerHeight;
  const remainingHeight = viewportHeight - pixels;
  return remainingHeight;
};

export default getErrorMessage;

export const debounce = (func, timeout = 2000) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

// Function to generate an array of dates for the next 7 days
export const generateNext7Days = () => {
  const today = new Date(); // Get the current date
  const next7Days = [];

  for (let i = 1; i <= 7; i++) {
    const date = new Date(today); // Create a new date object
    date.setDate(today.getDate() + i); // Add 'i' days to the current date
    next7Days.push(date.toISOString().split('T')[0]); // Push the date in YYYY-MM-DD format
  }

  return next7Days;
};

export const get_analyst_list = async () => {
  try {
    const response = await axiosInstance.get(`/v1/qc/analyst_availability`);
    const data = await response.data;
    // console.log({ analyst_data: data });
    return data.analysts;
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  }
};

export const generateDateInGenericStringFormat = (date) => {
  const dd = date.getDate();
  const mm = date.getMonth();
  const yyyy = date.getFullYear();
  const hh = date.getHours();
  const min = date.getMinutes();
  const ss = date.getSeconds();
  const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
  return d;
};


/**
 * utiility hof function to fetch the hidden fields and set it.
 * @param {setter} set_hidden_fields
 */
export const fetch_hidden_fields = async (set_hidden_fields = () => { }) => {
  try {
    const response = await axiosInstance.get(`/v1/qc/get_hidden_fields`);
    const result = await response.data;
    if (result?.status === "success") {
      const updated_hidden_fields = result.data;
      console.log({ updated_hidden_fields });
      set_hidden_fields(() => ({
        open_po: updated_hidden_fields.open_po || [],
        sample_status: updated_hidden_fields.sample_status || [],
        schedule: updated_hidden_fields.schedule || [],
      }));
    }
  } catch (error) {
    logout_if_403(error);
    console.log(getErrorMessage(error));
  }
};

export const logout_if_403 = (error) => {
  if (error?.response?.status === 403) {
    localStorage.clear();
    const auth_cookies = Cookies.withAttributes({
      secure: true,
    });
    auth_cookies.remove("current_user");
    auth_cookies.remove("isAuth");
    window.location.reload();
  }
};